<div class="div-supletivo" id="topo">

    <div class="div-main-body">
        
        <div class="div-header">

            <mat-toolbar class="barra-topo">

                <div class="div-img-logo">
                    <img  class="img-logo" src="../../../../assets/portal_logos.png">
                </div>

            </mat-toolbar>

        </div>

        <div class="div-body">

            <picture>
                <source media="(min-width: 768px)" srcset="../../../../assets/afiliacao/renda-extra.PNG">
                <source media="(min-width: 450px)" srcset="../../../../assets/afiliacao/renda-extra-mobile.PNG">
                <img class="img-body" src="../../../../assets/afiliacao/renda-extra-mobile.PNG">
            </picture>
            
            <div class="div-cadastro" id="cadastro">

                <div class="div-crie">
                    <p class="p-cadastro">
                        CRIE SUA LOJA E COMECE A GANHAR DINHEIRO AGORA.
                    </p>
                </div>

                <div class="div-faca">
                    
                    <p class="p-faca">
                        FAÇA SEU CADASTRO!
                    </p>

                    <form [formGroup]="form">
    
                        <div class="div-form">
                            
                            <div class="div-form-nome-sobrenome">
                                <div class="div-form-field" style="width: 50%;">
                                    <mat-form-field>
                                        <mat-label>Nome</mat-label>
                                        <input appTitlecase formControlName="nome" matInput outline:none>
                                        <!-- <mat-error>Informação necessária</mat-error> -->
                                    </mat-form-field>
                                </div>

                                <div class="div-form-field" style="width: 50%;">
                                    <mat-form-field>
                                        <mat-label>Sobrenome</mat-label>
                                        <input appTitlecase formControlName="sobrenome" matInput outline:none>
                                        <!-- <mat-error>Informação necessária</mat-error> -->
                                    </mat-form-field>
                                </div>
                            </div>
        
                            <div class="div-form-email-data-nascimento">
                                <div class="div-form-field" style="width: 60%;">
                                    <mat-form-field>
                                        <mat-label>Email</mat-label>
                                        <input formControlName="email" id="idEmail" matInput appLowwercase ngModel email autocomplete="on" outline:none>
                                        <!-- <mat-error>E-mail Incorreto, por favor corrigir.</mat-error> -->
                                    </mat-form-field>
                                </div>

                                <div class="div-form-field" style="width: 40%;">
                                    <mat-form-field>
                                        <mat-label>Data de Nascimento</mat-label>
                                        <input formControlName="dataNascimento" matInput type="date" appTitlecase outline:none>
                                        <!-- <mat-error>E-mail Incorreto, por favor corrigir.</mat-error> -->
                                    </mat-form-field>
                                </div>
                            </div>

                            <div class="div-form-estado-cidade-telefone">
                                <div class="div-form-field" style="width: 30%;">
                                    <mat-form-field>
                                        <mat-label>Estado</mat-label>
                                        <mat-select formControlName="estado">
                                            <mat-option *ngFor="let estado of estados" [value]="estado" appTitlecase outline:none>
                                                {{ estado }}
                                            </mat-option>
                                        </mat-select>
                                        <!-- <mat-error>Informação necessária</mat-error> -->
                                    </mat-form-field>
                                </div>

                                <div class="div-form-field" style="width: 30%;">
                                    <mat-form-field>
                                        <mat-label>Cidade</mat-label>
                                        <input formControlName="cidade" matInput appTitlecase outline:none>
                                        <!-- <mat-error>Informação necessária</mat-error> -->
                                    </mat-form-field>
                                </div>
            
                                <div class="div-form-field" style="width: 30%;">
                                    <mat-form-field>
                                        <mat-label>Telefone</mat-label>
                                        <input formControlName="telefone" [mask]="maskCelular" matInput appTitlecase outline:none>
                                        <!-- <mat-error>Informação necessária</mat-error> -->
                                    </mat-form-field>
                                </div>
                            </div>
        
                            <div class="div-form-cpf-enviar" style="justify-content: flex-start;">
                                <div class="div-form-field" style="width: 40%;">
                                    <mat-form-field>
                                        <mat-label>CPF</mat-label>
                                        <input formControlName="cpf" [mask]="cpfMask" matInput appTitlecase outline:none>
                                        <!-- <mat-error *ngIf="form.get('cpf').hasError('cpfInvalido')">CPF inválido</mat-error>
                                        <mat-error *ngIf="form.get('cpf').hasError('required')">Informação necessária</mat-error> -->
                                    </mat-form-field>
                                </div>
            
                                <button mat-raised-button class="b-cadastrar"> 
                                    <p class="p-cadastrar">
                                        CADASTRAR
                                    </p>
                                </button>
                            </div>
        
                        </div>
        
                    </form>

                    <div class="div-li-condordo">

                        <mat-checkbox></mat-checkbox>
                        
                        <p class="p-li-condordo">
                            Li e concordo com a política de privacidade, REGULAMENTO PROGRAMA DE AFILIADO bem como com o tratamento dos meus dados para a finalidade prevista neste formulário. Ao continuar, você aceita os termos do REGULAMENTO PROGRAMA DE AFILIADO.
                        </p>

                    </div>

                </div>

            </div>

            <picture>
                <source media="(min-width: 768px)" srcset="../../../../assets/afiliacao/veja-como-e-facil.png">
                <source media="(min-width: 450px)" srcset="../../../../assets/afiliacao/veja-como-e-facil-mobile.png">
                <img class="img-body" src="../../../../assets/afiliacao/veja-como-e-facil-mobile.png">
            </picture>

            <div class="div-inscreva-se">
    
                <button mat-raised-button class="b-cadastrar" (click)="criarCadastro()">
                    <p class="p-cadastrar">
                        CRIAR LOJA
                    </p>
                </button>
    
            </div>

            <div class="div-duvidas" id="duvidas">

                <div class="div-tartartart">
                    <p class="p-duvidas">
                        <strong>DÚVIDAS FREQUENTES</strong>
                    </p>

                    <mat-divider></mat-divider>
                    
                    <div class="div-separacao-colunas">
                        <div class="div-coluna1">
                            <mat-accordion class="noselect">
                                <mat-expansion-panel class="asdfg">
                                    <mat-expansion-panel-header class="header cinza">
                                        <mat-panel-title class="realizar-exercicios"><p class="p-numeracao">1.</p><p class="p-pergunta">O que é o programa Rede de Empreendedores Digitais?</p></mat-panel-title>
                                    </mat-expansion-panel-header>
                                    <p class="p-resposta">É o programa de afiliados promovido pela Estácio através da plataforma onde você poderá empreender digitalmente e aumentar a sua renda promovendo a educação com a divulgação dos cursos de graduação, graduação tecnológica e pós-graduação, nas modalidades presencial ou à distância ministrados pela Estácio e ser comissionado pela venda gerada via compartilhamento do link da loja virtual criada na plataforma da Rede de Empreendedores Digitais.</p>
                                </mat-expansion-panel>

                                <mat-expansion-panel class="asdfg">
                                    <mat-expansion-panel-header class="header cinza">
                                        <mat-panel-title class="realizar-exercicios"><p class="p-numeracao">2.</p><p class="p-pergunta">Como funciona a Rede de Empreendedores Digitais?</p></mat-panel-title>
                                    </mat-expansion-panel-header>
                                    <p class="p-resposta">Primeiro faça o seu cadastro e você terá uma loja virtual exclusiva com todo material necessário para começar a planejar sua estratégia de divulgação. A sua loja personalizada permite a divulgação de um link, através de suas redes sociais. Quanto mais você divulga, maior o número de pessoas terá acesso à sua lojinha e mais oportunidade de ganho. As pessoas que clicarem no seu link poderão realizar as suas inscrições e todo processo de matrícula online, inclusive o pagamento do boleto de matrícula.</p>
                                </mat-expansion-panel>

                                <mat-expansion-panel class="asdfg">
                                    <mat-expansion-panel-header class="header cinza">
                                        <mat-panel-title class="realizar-exercicios"><p class="p-numeracao">3.</p><p class="p-pergunta">Qual é a remuneração?</p></mat-panel-title>
                                    </mat-expansion-panel-header>
                                    <p class="p-resposta">Para cada aluno efetivamente matriculado, será contemplado com a Premiação em dinheiro na quantia de R$110,00 por meio de depósito na conta bancária de sua titularidade que venha a ser informada no cadastro. O pagamento da Premiação será feito de forma parcelada em duas vezes de igual valor. A primeira parcela será paga em até 10 (dez) dias após a compensação bancária do pagamento realizado da primeira mensalidade efetuado pelo aluno. E a segunda parcela será paga no dia 24 (vinte e quatro) do mês imediatamente subsequente ao encerramento do ciclo de captação da Estácio. Exemplo: Se 4 pessoas realizam a matrícula no dia 5 de setembro, você ganha R$ 440,00 em sua conta corrente. Sendo, R$220,00 10 dias após a compensação do boleto do candidato e R$ 220,00 no dia 24 do mês imediatamente após o encerramento do período de captação.</p>
                                </mat-expansion-panel>

                                <mat-expansion-panel class="asdfg">
                                    <mat-expansion-panel-header class="header cinza">
                                        <mat-panel-title class="realizar-exercicios"><p class="p-numeracao">4.</p><p class="p-pergunta">Terei algum custo/investimento para participar do programa?</p></mat-panel-title>
                                    </mat-expansion-panel-header>
                                    <p class="p-resposta">Fazer parte da Rede de Empreendedores Digitais é totalmente grátis! Você não precisa fazer nenhum investimento inicial, basta criar sua loja na plataforma, divulgar os cursos através do seu link da sua loja virtual e ganhar a partir das matrículas efetivamente realizadas.</p>
                                </mat-expansion-panel>

                                <mat-expansion-panel class="asdfg">
                                    <mat-expansion-panel-header class="header cinza">
                                        <mat-panel-title class="realizar-exercicios"><p class="p-numeracao">5.</p><p class="p-pergunta">O que eu preciso para ser um Empreendedor Digital?</p></mat-panel-title>
                                    </mat-expansion-panel-header>
                                    <p class="p-resposta">Primeiramente, ser um empreendedor, gostar de desafios, e claro, ter muita vontade de vender. Depois disso, você precisa de: • CPF • Conta corrente na mesma titularidade.</p>
                                </mat-expansion-panel>

                                <mat-expansion-panel class="asdfg">
                                    <mat-expansion-panel-header class="header cinza">
                                        <mat-panel-title class="realizar-exercicios"><p class="p-numeracao">6.</p><p class="p-pergunta">Preciso ter um CNPJ para me cadastrar no programa?</p></mat-panel-title>
                                    </mat-expansion-panel-header>
                                    <p class="p-resposta">Não, é necessário apenas CPF e que a conta bancária esteja cadastrada neste CPF informado na hora do cadastro. A conta bancária de pagamento dos valores somente é efetivada se o CPF desta conta for o mesmo da sua loja. Fique atento!</p>
                                </mat-expansion-panel>
                            </mat-accordion>
                        </div>
                        
                        <div class="div-coluna2">
                            <mat-accordion class="noselect">
                                <mat-expansion-panel class="asdfg">
                                    <mat-expansion-panel-header class="header cinza">
                                        <mat-panel-title class="realizar-exercicios"><p class="p-numeracao">7.</p><p class="p-pergunta">Posso fazer parte da Rede sendo beneficiário do INSS (Seguro-Desemprego, auxílio-doença ou bolsa família e/ou outros)?</p></mat-panel-title>
                                    </mat-expansion-panel-header>
                                    <p class="p-resposta">Todo e qualquer benefício concedido pelo INSS são regidos por normas próprias de concessão, assim como regras claras de suspensão. Consulte no site as condicionalidades do seu benefício: www.beneficiossociais.caixa.gov.br/consulta/beneficio/04.01.00-00_00.asp A Estácio não se responsabiliza por qualquer perda ou suspensão do benefício concedido e informa que toda e qualquer dúvida com relação a eventuais benefícios recebidos pelo segurado, poderão ser sanadas diretamente junto à Agência do INSS de sua cidade.</p>
                                </mat-expansion-panel>

                                <mat-expansion-panel class="asdfg">
                                    <mat-expansion-panel-header class="header cinza">
                                        <mat-panel-title class="realizar-exercicios"><p class="p-numeracao">8.</p><p class="p-pergunta">Como fazer o meu cadastro na Rede de Empreendedores Digitais?</p></mat-panel-title>
                                    </mat-expansion-panel-header>
                                    <p class="p-resposta">O cadastro deve ser feito através do link <a href="https://rede.estacio.br/" target="_blank">https://rede.estacio.br/</a> onde você informará seus dados e irá gerar sua senha de acesso a sua loja virtual. Pronto, é só divulgar.</p>
                                </mat-expansion-panel>

                                <mat-expansion-panel class="asdfg">
                                    <mat-expansion-panel-header class="header cinza">
                                        <mat-panel-title class="realizar-exercicios"><p class="p-numeracao">9.</p><p class="p-pergunta">Criei a loja, e agora, como faço pra vender?</p></mat-panel-title>
                                    </mat-expansion-panel-header>
                                    <p class="p-resposta">Assim que você cria sua loja já pode começar a divulgar compartilhando seu link. Na sua plataforma terá um menu “Instruções” com muito conteúdo para você aprender mais sobre seu novo negócio. Então a dica é: assista o vídeo link do vídeo e visite o menu de instruções para entender sua plataforma e alavancar suas vendas.</p>
                                </mat-expansion-panel>

                                <mat-expansion-panel class="asdfg">
                                    <mat-expansion-panel-header class="header cinza">
                                        <mat-panel-title class="realizar-exercicios"><p class="p-numeracao">10.</p><p class="p-pergunta">Fiz uma venda em minha loja e não aparece em Meus Negócios, por quê?</p></mat-panel-title>
                                    </mat-expansion-panel-header>
                                    <p class="p-resposta">Para fins de Premiação, serão considerados efetivamente matriculados os candidatos que forem devidamente aprovados no processo seletivo para ingresso na IES ESTÁCIO, e que efetivamente aceitarem o respectivo contrato educacional, pagarem a primeira mensalidade correspondente e realizarem a entrega da documentação comprobatória para preenchimento dos pré-requisitos de seu respectivo curso, em até 30 (trinta) dias do registro da indicação, e não trancarem a matrícula do respectivo curso até a data do pagamento integral da Premiação. No item 2 do termo aceito para Criação da Loja na Rede, você conseguirá verificar os motivos que podem ocorrer de forma transparente e detalhada.</p>
                                </mat-expansion-panel>

                                <mat-expansion-panel class="asdfg">
                                    <mat-expansion-panel-header class="header cinza">
                                        <mat-panel-title class="realizar-exercicios"><p class="p-numeracao">11.</p><p class="p-pergunta">Tenho uma empresa, posso fazer parte da Rede?</p></mat-panel-title>
                                    </mat-expansion-panel-header>
                                    <p class="p-resposta">A Rede de Empreendedores Digitais é para pessoa física. Se você possui uma empresa e quer ser um parceiro Estácio, você terá outras vantagens Acesse: <a href="https://consultor.estacio.br/representantes/" target="_blank">https://consultor.estacio.br/representantes/</a></p>
                                </mat-expansion-panel>

                                <mat-expansion-panel class="asdfg">
                                    <mat-expansion-panel-header class="header cinza">
                                        <mat-panel-title class="realizar-exercicios"><p class="p-numeracao">10.</p><p class="p-pergunta">Regulamento</p></mat-panel-title>
                                    </mat-expansion-panel-header>
                                    <p class="p-resposta"><a href="" target="_blank">Regulamento</a></p>
                                </mat-expansion-panel>
                            </mat-accordion>
                        </div>
                    </div>
                </div>

            </div>

        </div>

        <div class="div-rodape">

            <div id="icones-barra-rodape" class="div-icones">
                <div class="icones">
                    <img class="img-icones" src="../../../../assets/afiliacao/icon-red-user.png">
                    <p class="p-icones">
                        <strong>SEJA UM AFILIADO</strong>
                    </p>
                </div>

                <div class="icones" (click)="logout()">
                    <img class="img-icones" src="../../../../assets/afiliacao/icon-red-user.png">
                    <p class="p-icones">
                        <strong>LOGIN</strong>
                    </p>
                </div>

                <div class="icones" (click)="duvidasFrequentes()">
                    <img class="img-icones" src="../../../../assets/afiliacao/icon-red-question.png">
                    <p class="p-icones">
                        <strong>DÚVIDAS FREQUENTES</strong>
                    </p>
                </div>

                <div class="icones">
                    <img class="img-icones" src="../../../../assets/afiliacao/icon-red-email.png">
                    <p class="p-icones">
                        <strong>FALE CONOSCO</strong>
                    </p>
                </div>
            </div>

        </div>

    </div>

</div>

<div class="div-nacionaltec">

    <div class="div-main-body">
        
        <div class="div-header">

            <mat-toolbar class="barra-topo nacional-azul">

                <div class="div-img-logo">
                    <img  class="img-logo nacional-logo" src="../../../../assets/logo_nacionaltec-branco-fundo-azul.png">
                </div>

            </mat-toolbar>

        </div>

        <div class="div-body">

            <picture class="fundo-nacional">
                <source media="(min-width: 768px)" srcset="../../../../assets/afiliacao/renda-extra-nacional.PNG">
                <source media="(min-width: 450px)" srcset="../../../../assets/afiliacao/renda-extra-mobile-nacional.PNG">
                <img class="img-body" src="../../../../assets/afiliacao/renda-extra-mobile-nacional.PNG">
            </picture>
            
            <div class="div-cadastro nacional-azul" id="cadastro">

                <div class="div-crie">
                    <p class="p-cadastro">
                        CRIE SUA LOJA E COMECE A GANHAR DINHEIRO AGORA.
                    </p>
                </div>

                <div class="div-faca">
                    
                    <p class="p-faca">
                        FAÇA SEU CADASTRO!
                    </p>

                    <form [formGroup]="form">
    
                        <div class="div-form">
                            
                            <div class="div-form-nome-sobrenome">
                                <div class="div-form-field" style="width: 50%;">
                                    <mat-form-field>
                                        <mat-label>Nome</mat-label>
                                        <input appTitlecase formControlName="nome" matInput outline:none>
                                    </mat-form-field>
                                </div>

                                <div class="div-form-field" style="width: 50%;">
                                    <mat-form-field>
                                        <mat-label>Sobrenome</mat-label>
                                        <input appTitlecase formControlName="sobrenome" matInput outline:none>
                                    </mat-form-field>
                                </div>
                            </div>
        
                            <div class="div-form-email-data-nascimento">
                                <div class="div-form-field" style="width: 60%;">
                                    <mat-form-field>
                                        <mat-label>Email</mat-label>
                                        <input formControlName="email" id="idEmail" matInput appLowwercase ngModel email autocomplete="on" outline:none>
                                    </mat-form-field>
                                </div>

                                <div class="div-form-field" style="width: 40%;">
                                    <mat-form-field>
                                        <mat-label>Data de Nascimento</mat-label>
                                        <input formControlName="dataNascimento" matInput type="date" appTitlecase outline:none>
                                    </mat-form-field>
                                </div>
                            </div>

                            <div class="div-form-estado-cidade-telefone">
                                <div class="div-form-field" style="width: 30%;">
                                    <mat-form-field>
                                        <mat-label>Estado</mat-label>
                                        <mat-select formControlName="estado">
                                            <mat-option *ngFor="let estado of estados" [value]="estado" appTitlecase outline:none>
                                                {{ estado }}
                                            </mat-option>
                                        </mat-select>
                                    </mat-form-field>
                                </div>

                                <div class="div-form-field" style="width: 30%;">
                                    <mat-form-field>
                                        <mat-label>Cidade</mat-label>
                                        <input formControlName="cidade" matInput appTitlecase outline:none>
                                    </mat-form-field>
                                </div>
            
                                <div class="div-form-field" style="width: 30%;">
                                    <mat-form-field>
                                        <mat-label>Telefone</mat-label>
                                        <input formControlName="telefone" [mask]="maskCelular" matInput appTitlecase outline:none>
                                    </mat-form-field>
                                </div>
                            </div>
        
                            <div class="div-form-cpf-enviar" style="justify-content: flex-start;">
                                <div class="div-form-field" style="width: 40%;">
                                    <mat-form-field>
                                        <mat-label>CPF</mat-label>
                                        <input formControlName="cpf" [mask]="cpfMask" matInput appTitlecase outline:none>
                                    </mat-form-field>
                                </div>
            
                                <button mat-raised-button class="b-cadastrar"> 
                                    <p class="p-cadastrar">
                                        CADASTRAR
                                    </p>
                                </button>
                            </div>
        
                        </div>
        
                    </form>

                    <div class="div-li-condordo">

                        <mat-checkbox></mat-checkbox>
                        
                        <p class="p-li-condordo">
                            Li e concordo com a política de privacidade, REGULAMENTO PROGRAMA DE AFILIADO bem como com o tratamento dos meus dados para a finalidade prevista neste formulário. Ao continuar, você aceita os termos do REGULAMENTO PROGRAMA DE AFILIADO.
                        </p>

                    </div>

                </div>

            </div>

            <picture class="fundo-nacional">
                <source media="(min-width: 768px)" srcset="../../../../assets/afiliacao/veja-como-e-facil-nacional.png">
                <source media="(min-width: 450px)" srcset="../../../../assets/afiliacao/veja-como-e-facil-mobile-nacional.png">
                <img class="img-body" src="../../../../assets/afiliacao/veja-como-e-facil-mobile-nacional.png">
            </picture>

            <div class="div-inscreva-se-nacional">
    
                <button mat-raised-button class="b-cadastrar" (click)="criarCadastro()">
                    <p class="p-cadastrar">
                        CRIAR LOJA
                    </p>
                </button>
    
            </div>

            <div class="div-duvidas-nacional" id="duvidas">

                <div class="div-tartartart">
                    <p class="p-duvidas">
                        <strong>DÚVIDAS FREQUENTES</strong>
                    </p>

                    <mat-divider class="nacional-verde"></mat-divider>

                    <div class="div-separacao-colunas">
                        <div>
                            <mat-accordion class="noselect">
                                <mat-expansion-panel class="asdfg azul">
                                    <mat-expansion-panel-header class="header cinza">
                                        <mat-panel-title class="realizar-exercicios nacional-branco"><p class="p-numeracao amarelo">1.</p><p class="p-pergunta">O que é o programa Rede de Empreendedores Digitais?</p></mat-panel-title>
                                    </mat-expansion-panel-header>
                                    <p class="p-resposta nacional-branco">É o programa de afiliados promovido pela Estácio através da plataforma onde você poderá empreender digitalmente e aumentar a sua renda promovendo a educação com a divulgação dos cursos de graduação, graduação tecnológica e pós-graduação, nas modalidades presencial ou à distância ministrados pela Estácio e ser comissionado pela venda gerada via compartilhamento do link da loja virtual criada na plataforma da Rede de Empreendedores Digitais.</p>
                                </mat-expansion-panel>

                                <mat-expansion-panel class="asdfg azul">
                                    <mat-expansion-panel-header class="header cinza">
                                        <mat-panel-title class="realizar-exercicios nacional-branco"><p class="p-numeracao amarelo">2.</p><p class="p-pergunta">Como funciona a Rede de Empreendedores Digitais?</p></mat-panel-title>
                                    </mat-expansion-panel-header>
                                    <p class="p-resposta nacional-branco">Primeiro faça o seu cadastro e você terá uma loja virtual exclusiva com todo material necessário para começar a planejar sua estratégia de divulgação. A sua loja personalizada permite a divulgação de um link, através de suas redes sociais. Quanto mais você divulga, maior o número de pessoas terá acesso à sua lojinha e mais oportunidade de ganho. As pessoas que clicarem no seu link poderão realizar as suas inscrições e todo processo de matrícula online, inclusive o pagamento do boleto de matrícula.</p>
                                </mat-expansion-panel>

                                <mat-expansion-panel class="asdfg azul">
                                    <mat-expansion-panel-header class="header cinza">
                                        <mat-panel-title class="realizar-exercicios nacional-branco"><p class="p-numeracao amarelo">3.</p><p class="p-pergunta">Qual é a remuneração?</p></mat-panel-title>
                                    </mat-expansion-panel-header>
                                    <p class="p-resposta nacional-branco">Para cada aluno efetivamente matriculado, será contemplado com a Premiação em dinheiro na quantia de R$110,00 por meio de depósito na conta bancária de sua titularidade que venha a ser informada no cadastro. O pagamento da Premiação será feito de forma parcelada em duas vezes de igual valor. A primeira parcela será paga em até 10 (dez) dias após a compensação bancária do pagamento realizado da primeira mensalidade efetuado pelo aluno. E a segunda parcela será paga no dia 24 (vinte e quatro) do mês imediatamente subsequente ao encerramento do ciclo de captação da Estácio. Exemplo: Se 4 pessoas realizam a matrícula no dia 5 de setembro, você ganha R$ 440,00 em sua conta corrente. Sendo, R$220,00 10 dias após a compensação do boleto do candidato e R$ 220,00 no dia 24 do mês imediatamente após o encerramento do período de captação.</p>
                                </mat-expansion-panel>

                                <mat-expansion-panel class="asdfg azul">
                                    <mat-expansion-panel-header class="header cinza">
                                        <mat-panel-title class="realizar-exercicios nacional-branco"><p class="p-numeracao amarelo">4.</p><p class="p-pergunta">Terei algum custo/investimento para participar do programa?</p></mat-panel-title>
                                    </mat-expansion-panel-header>
                                    <p class="p-resposta nacional-branco">Fazer parte da Rede de Empreendedores Digitais é totalmente grátis! Você não precisa fazer nenhum investimento inicial, basta criar sua loja na plataforma, divulgar os cursos através do seu link da sua loja virtual e ganhar a partir das matrículas efetivamente realizadas.</p>
                                </mat-expansion-panel>

                                <mat-expansion-panel class="asdfg azul">
                                    <mat-expansion-panel-header class="header cinza">
                                        <mat-panel-title class="realizar-exercicios nacional-branco"><p class="p-numeracao amarelo">5.</p><p class="p-pergunta">O que eu preciso para ser um Empreendedor Digital?</p></mat-panel-title>
                                    </mat-expansion-panel-header>
                                    <p class="p-resposta nacional-branco">Primeiramente, ser um empreendedor, gostar de desafios, e claro, ter muita vontade de vender. Depois disso, você precisa de: • CPF • Conta corrente na mesma titularidade.</p>
                                </mat-expansion-panel>

                                <mat-expansion-panel class="asdfg azul">
                                    <mat-expansion-panel-header class="header cinza">
                                        <mat-panel-title class="realizar-exercicios nacional-branco"><p class="p-numeracao amarelo">6.</p><p class="p-pergunta">Preciso ter um CNPJ para me cadastrar no programa?</p></mat-panel-title>
                                    </mat-expansion-panel-header>
                                    <p class="p-resposta nacional-branco">Não, é necessário apenas CPF e que a conta bancária esteja cadastrada neste CPF informado na hora do cadastro. A conta bancária de pagamento dos valores somente é efetivada se o CPF desta conta for o mesmo da sua loja. Fique atento!</p>
                                </mat-expansion-panel>
                            </mat-accordion>
                        </div>
                        
                        <div>
                            <mat-accordion class="noselect">
                                <mat-expansion-panel class="asdfg azul">
                                    <mat-expansion-panel-header class="header cinza">
                                        <mat-panel-title class="realizar-exercicios nacional-branco"><p class="p-numeracao amarelo">7.</p><p class="p-pergunta">Posso fazer parte da Rede sendo beneficiário do INSS (Seguro-Desemprego, auxílio-doença ou bolsa família e/ou outros)?</p></mat-panel-title>
                                    </mat-expansion-panel-header>
                                    <p class="p-resposta nacional-branco">Todo e qualquer benefício concedido pelo INSS são regidos por normas próprias de concessão, assim como regras claras de suspensão. Consulte no site as condicionalidades do seu benefício: www.beneficiossociais.caixa.gov.br/consulta/beneficio/04.01.00-00_00.asp A Estácio não se responsabiliza por qualquer perda ou suspensão do benefício concedido e informa que toda e qualquer dúvida com relação a eventuais benefícios recebidos pelo segurado, poderão ser sanadas diretamente junto à Agência do INSS de sua cidade.</p>
                                </mat-expansion-panel>

                                <mat-expansion-panel class="asdfg azul">
                                    <mat-expansion-panel-header class="header cinza">
                                        <mat-panel-title class="realizar-exercicios nacional-branco"><p class="p-numeracao amarelo">8.</p><p class="p-pergunta">Como fazer o meu cadastro na Rede de Empreendedores Digitais?</p></mat-panel-title>
                                    </mat-expansion-panel-header>
                                    <p class="p-resposta nacional-branco">O cadastro deve ser feito através do link <a href="https://rede.estacio.br/" target="_blank">https://rede.estacio.br/</a> onde você informará seus dados e irá gerar sua senha de acesso a sua loja virtual. Pronto, é só divulgar.</p>
                                </mat-expansion-panel>

                                <mat-expansion-panel class="asdfg azul">
                                    <mat-expansion-panel-header class="header cinza">
                                        <mat-panel-title class="realizar-exercicios nacional-branco"><p class="p-numeracao amarelo">9.</p><p class="p-pergunta">Criei a loja, e agora, como faço pra vender?</p></mat-panel-title>
                                    </mat-expansion-panel-header>
                                    <p class="p-resposta nacional-branco">Assim que você cria sua loja já pode começar a divulgar compartilhando seu link. Na sua plataforma terá um menu “Instruções” com muito conteúdo para você aprender mais sobre seu novo negócio. Então a dica é: assista o vídeo link do vídeo e visite o menu de instruções para entender sua plataforma e alavancar suas vendas.</p>
                                </mat-expansion-panel>

                                <mat-expansion-panel class="asdfg azul">
                                    <mat-expansion-panel-header class="header cinza">
                                        <mat-panel-title class="realizar-exercicios nacional-branco"><p class="p-numeracao amarelo">10.</p><p class="p-pergunta">Fiz uma venda em minha loja e não aparece em Meus Negócios, por quê?</p></mat-panel-title>
                                    </mat-expansion-panel-header>
                                    <p class="p-resposta nacional-branco">Para fins de Premiação, serão considerados efetivamente matriculados os candidatos que forem devidamente aprovados no processo seletivo para ingresso na IES ESTÁCIO, e que efetivamente aceitarem o respectivo contrato educacional, pagarem a primeira mensalidade correspondente e realizarem a entrega da documentação comprobatória para preenchimento dos pré-requisitos de seu respectivo curso, em até 30 (trinta) dias do registro da indicação, e não trancarem a matrícula do respectivo curso até a data do pagamento integral da Premiação. No item 2 do termo aceito para Criação da Loja na Rede, você conseguirá verificar os motivos que podem ocorrer de forma transparente e detalhada.</p>
                                </mat-expansion-panel>

                                <mat-expansion-panel class="asdfg azul">
                                    <mat-expansion-panel-header class="header cinza">
                                        <mat-panel-title class="realizar-exercicios nacional-branco"><p class="p-numeracao amarelo">11.</p><p class="p-pergunta">Tenho uma empresa, posso fazer parte da Rede?</p></mat-panel-title>
                                    </mat-expansion-panel-header>
                                    <p class="p-resposta nacional-branco">A Rede de Empreendedores Digitais é para pessoa física. Se você possui uma empresa e quer ser um parceiro Estácio, você terá outras vantagens Acesse: <a href="https://consultor.estacio.br/representantes/" target="_blank">https://consultor.estacio.br/representantes/</a></p>
                                </mat-expansion-panel>

                                <mat-expansion-panel class="asdfg azul">
                                    <mat-expansion-panel-header class="header cinza">
                                        <mat-panel-title class="realizar-exercicios nacional-branco"><p class="p-numeracao amarelo">10.</p><p class="p-pergunta">Regulamento</p></mat-panel-title>
                                    </mat-expansion-panel-header>
                                    <p class="p-resposta nacional-branco"><a href="" target="_blank">Regulamento</a></p>
                                </mat-expansion-panel>
                            </mat-accordion>
                        </div>
                    </div>
                </div>

            </div>

        </div>

        <div class="div-rodape nacional-azul">

            <div id="icones-barra-rodape" class="div-icones">
                <div class="icones">
                    <img class="img-icones" src="../../../../assets/afiliacao/icon-white-user.png">
                    <p class="p-icones nacional-branco">
                        <strong>SEJA UM AFILIADO</strong>
                    </p>
                </div>

                <div class="icones" (click)="logout()">
                    <img class="img-icones" src="../../../../assets/afiliacao/icon-white-user.png">
                    <p class="p-icones nacional-branco">
                        <strong>LOGIN</strong>
                    </p>
                </div>

                <div class="icones" (click)="duvidasFrequentes()">
                    <img class="img-icones" src="../../../../assets/afiliacao/icon-white-question.png">
                    <p class="p-icones nacional-branco">
                        <strong>DÚVIDAS FREQUENTES</strong>
                    </p>
                </div>

                <div class="icones">
                    <img class="img-icones" src="../../../../assets/afiliacao/icon-white-email.png">
                    <p class="p-icones nacional-branco">
                        <strong>FALE CONOSCO</strong>
                    </p>
                </div>
            </div>

        </div>

    </div>

</div>